import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

import MaynLayout from '../../Core/MainLayout'
import PageLayout from '../../Core/PageLayout'
import TitleBlock from '../../Core/TitleBlock'
import Dashboard from '../../Core/Dashboard'
import CategoriesIcon from '../../Icons/Categories2'
import Form from './Form'
import { getCustomer } from '../../../store/customers/actions'
import { selectCustomer } from '../../../store/customers/selectors'

const CustomerFormScreen = () => {
  const { t } = useTranslation()
  const { id: companyId, customerId } = useParams()
  const dispatch = useDispatch()
  const customer = useSelector(selectCustomer)
  const isCreate = customerId === 'create'

  useEffect(() => {
    if (!isCreate && customerId) {
      dispatch(getCustomer(companyId, customerId))
    }
  }, [dispatch, companyId, customerId, isCreate])

  return (
    <MaynLayout>
      <Dashboard>
        <TitleBlock
          title={t(`Categories / ${isCreate ? 'Create new customer' : 'Edit customer'}`)}
        >
          <CategoriesIcon />
        </TitleBlock>
        <PageLayout>
          <Form
            companyId={companyId}
            customerId={customerId}
            isCreate={isCreate}
            initialFormData={isCreate ? null : customer}
          />
        </PageLayout>
      </Dashboard>
    </MaynLayout>
  )
}

export default CustomerFormScreen
